import drill_title from "@/components/drill_title.vue"
import jqUaAddcls from "@/assets/js/functions/jquery.ua_addclass.js"
import jsLsObj from "@/assets/js/functions/resetLsData.js"
import jsReset from "@/assets/js/functions/resetSaveObj.js"
import jsStg from "@/assets/js/functions/class_localStorage.js"
import jqFixed from "@/assets/js/functions/class_jqFixedWindow.js"
var ls = new jsStg.jsLocalStorage();
var fw = new jqFixed.jqfixedWindow();

export default {
	name: "home",
	props: {
		title: String,
		title_html: String,
		title_id: String,
		ls_key: String,
		jsonObj: Object,
		SettingObj: Object,
	},
	components: {
		drill_title,
	},
	data: function() {
		return {
			bool: {confirm: false, info: false, howto: false, finishAry: []},
			data: {info: "", howto: "", percentAry: []},
			bgcolors: {
				header: {background: this.SettingObj.bgcolors.header},
				footer: {background: this.SettingObj.bgcolors.footer},
				belt: {background: this.SettingObj.bgcolors.belt},
				button_heavy: {background: this.SettingObj.bgcolors.button_heavy, borderBottom: this.SettingObj.bgcolors.button_heavy_thick},
			},
		}
	},
	created: function() {
		var i;
		var ls_data = ls.getStorageJson(this.ls_key);
		// 保存データが存在しない場合は初期化（下記の保存データ項目を追加、削除する場合は Selection.vue、Home.vueとResult.vue内のリセット処理時処理も同じく揃えること）
		if (!ls_data) {
			ls_data = jsLsObj.resetLsData(this.title, this.title_id); // ls_data Objを初期化
			ls_data.saveAry = jsReset.resetSaveObj(this.jsonObj.qAry); // 単元単位でls_data.saveAry[n]を初期化

			for (i = 0; i < this.jsonObj.qAry.length; i++) {
				const id = this.jsonObj.qAry[i].head_id;
				this.data.percentAry[id] = 0; // 全単元で画面表示用に正解率を0に初期化（初回起動時のみ）
			}

			ls.setStorageJson(this.ls_key, ls_data);

		} else {
			// 成績パーセントデータを単元毎で取得し設定
			for (i = 0; i < ls_data.saveAry.length; i++) {
				const id = ls_data.saveAry[i].head_id;
				this.data.percentAry[id] = ls_data.saveAry[id].percent;
				this.bool.finishAry[id] = ls_data.saveAry[id].finishBool;
			}
		}

		return;
	},
	mounted: function() {
		// ユーザーエージェントよりclass属性（ua_sp、ua_tb、ua_pc）を追加
		jqUaAddcls.ua_addclass();
	},
	methods: {
		// 単元選択ボタンイベント
		selectHeader: function(current_hd) {
			
			var ls_data = ls.getStorageJson(this.ls_key);
			ls_data.current_head_id = current_hd;
			ls.setStorageJson(this.ls_key, ls_data);

			return;
		},
		// 確認イベント
		switchConfirm: function() {
			this.bool.confirm = !this.bool.confirm;
		},
		// 成績データを削除する処理
		removeStorage: function() {
			this.bool.confirm = !this.bool.confirm;

			// アプリタイトル毎で保存データをすべて消去
			var ls_data = ls.getStorageJson(this.ls_key);
			ls.removeStorage(this.ls_key);
			location.reload(); // ブラウザキャッシュを消去するリロード

			// 消去後に保存用Objを初期化
			ls_data = jsLsObj.resetLsData(this.title, this.title_id); // ls_data Objを初期化
			ls_data.saveAry = jsReset.resetSaveObj(this.jsonObj.qAry); // ls_data.saveAry[n]の初期化

			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// アプリの使い方ボタンイベント
		viewHowto: function() {
			const howto = this.SettingObj.howto;
			if (!this.bool.howto) {
				this.data.howto = howto;
				this.bool.howto = true;
				// fw.fixedWindow(".help_window"); // 背面スクロールを禁止（jQuery）

			} else {
				this.data.howto = "";
				this.bool.howto = false;
				// fw.releaseWindow(".help_window"); // 背面スクロール禁止を解除
			}
		},
		// アプリについてボタンイベント
		viewAppinfo: function() {
			const info = this.SettingObj.info;
			if (!this.bool.info) {
				this.data.info = info;
				this.bool.info = true;
				// fw.fixedWindow(".help_window");

			} else {
				this.data.info = "";
				this.bool.info = false;
				// fw.releaseWindow(".help_window");

			}
		},
	},
}
